var stickyHiddenButton = document.querySelector(".sticky_hidden");
var stickyShowButton = document.querySelector(".sticky_show");
var stickyContainer = document.getElementById("stickyContainer");

stickyHiddenButton.addEventListener("click", function () {
  stickyContainer.style.display = "none";
  stickyShowButton.style.display = "block";
});

stickyShowButton.addEventListener("click", function () {
  stickyContainer.style.display = "flex";
  stickyShowButton.style.display = "none";
});
window.addEventListener("scroll", function () {
  var stickyContainer = document.getElementById("stickyContainer");
  var stickyContainerShow = document.querySelector(".sticky_show");
  var scrollPosition = window.scrollY;
  var showTriggerPosition = 2800;
  var hideTriggerPosition = 12000;
  var hideTriggerPositionMobile = 22000;

  if (window.innerWidth <= 780) {
    stickyContainer.style.visibility = "visible";
    if (scrollPosition >= hideTriggerPositionMobile) {
      stickyContainer.style.visibility = "hidden";
      stickyContainerShow.style.visibility = "hidden";
    }
  } else {
    if (
      scrollPosition > showTriggerPosition &&
      scrollPosition < hideTriggerPosition
    ) {
      stickyContainer.style.visibility = "visible";
      stickyContainerShow.style.visibility = "visible";
    } else {
      stickyContainer.style.visibility = "hidden";
      stickyContainerShow.style.visibility = "hidden";
    }
  }
});
